import { Plus, Save, X } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header, Outcome } from "./AdminPagePrimitives";
import { formatDate } from "./admin-presentation";

import { useAdminDepartmentsWorkspace } from "./useAdminDepartmentsWorkspace";

export function DepartmentsPage({notify}: {notify: Notify}) {
  const { saving, rows, editing, setEditing, composerOpen, setComposerOpen, form, setForm, save, edit } = useAdminDepartmentsWorkspace({notify});
  return (
    <>
      <Header
        eyebrow="Organizasyon"
        title="Departmanlar"
        description="Uygulama kullanıcılarının bağlı olduğu kurumsal birimleri görüntüleyin."
        action={
          <button
            className="primary-button"
            onClick={() => {
              setEditing(null);
              setForm({ code: "", name: "", active: true });
              setComposerOpen(true);
            }}
          >
            <Plus size={15} /> Departman ekle
          </button>
        }
      />
      {composerOpen ? (
        <section className="inline-form-card">
          <div className="section-heading compact">
            <div>
              <span className="section-kicker">Organizasyon birimi</span>
              <h2>{editing ? "Departmanı düzenle" : "Departman oluştur"}</h2>
            </div>
            <button
              className="icon-button"
              aria-label="Departman formunu kapat"
              onClick={() => setComposerOpen(false)}
            >
              <X size={17} />
            </button>
          </div>
          <div className="inline-form-grid">
            <label>
              Departman kodu
              <input
                disabled={Boolean(editing)}
                value={form.code}
                placeholder="Örn. KALITE"
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    code: event.target.value,
                  }))
                }
              />
            </label>
            <label>
              Departman adı
              <input
                value={form.name}
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    name: event.target.value,
                  }))
                }
              />
            </label>
            {editing ? (
              <label>
                Durum
                <select
                  value={String(form.active)}
                  onChange={(event) =>
                    setForm((current) => ({
                      ...current,
                      active: event.target.value === "true",
                    }))
                  }
                >
                  <option value="true">Aktif</option>
                  <option value="false">Pasif</option>
                </select>
              </label>
            ) : null}
          </div>
          <div className="inline-form-actions">
            <button
              className="secondary-button"
              onClick={() => setComposerOpen(false)}
            >
              Vazgeç
            </button>
            <button className="approve-button" disabled={saving} onClick={save}>
              <Save size={15} /> Kaydet
            </button>
          </div>
        </section>
      ) : null}
      <section className="module-card">
        <div className="data-table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>Departman</th>
                <th>Kod</th>
                <th>Kullanıcı</th>
                <th>Durum</th>
                <th>Oluşturulma</th>
                <th aria-label="İşlem" />
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <strong>{row.name}</strong>
                  </td>
                  <td>{row.code}</td>
                  <td>{row.user_count}</td>
                  <td>
                    <Outcome value={row.active ? "SUCCESS" : "PASSIVE"} />
                  </td>
                  <td>{formatDate(row.created_at)}</td>
                  <td>
                    <button className="row-action" onClick={() => edit(row)}>
                      Düzenle
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}
